import { useAllOrders } from '@entities/schedule/api/useAllOrders';
import { Alert } from '@shared/ui/alert/alert';
import React from 'react'
import { useAlerts } from '@shared/api/useAlerts';
import { UnpaidOrderAlert } from '../unpaid-order-alert/unpaid-order-alert';
import { PersonalAlert } from '../personal-alert/personal-alert';
import { queryClient } from '@shared/api/query-client';
import { AnimatePresence } from 'framer-motion';

export const Alerts = () => {
	const {data: profile} = queryClient.getQueryData(['profile'])

	if(profile?.access_level !== 'basic'){
		return {
            basic: "",
            restricted: (
              <Alert
                title="Проверьте почту"
                subtitle="Подтвердите регистрацию, чтобы начать заниматься"
              />
            ),
          }[profile?.access_level]
	}

	return (
    <AnimatePresence initial={false}>
			<AlertsComponents/>
    </AnimatePresence>
  );
}

const AlertsComponents = () => {
	const { data: orders, isFetched: ordersIdFetched } = useAllOrders();
	const { data: alerts, isFetched: alertsIsFetched } = useAlerts();

	if((orders?.length === 0 && !alerts?.general?.length && !alerts?.personal?.length) || !ordersIdFetched || !alertsIsFetched) return null

	return <>
		{
		[
			...orders?.map((el) => <UnpaidOrderAlert orderId={el?.id} />),
			...alerts?.general?.map((el) => (
				<Alert subtitle={el?.text} type={el?.type} key={el?.text} index={el?.text}/>
			)),
			...alerts?.personal?.map((el) => (
				<PersonalAlert type={el?.type} teacher={el.teacher} key={el?.teacher?.teacher_slug}/>
			)),
		][0]
	}
	</>
}